import {
  adminClient,
  inferAdditionalFields,
  magicLinkClient,
  organizationClient,
} from 'better-auth/client/plugins'
import { nextCookies } from 'better-auth/next-js'
import { createAuthClient } from 'better-auth/react'
import { env } from '@/env/client'
import type { TAuth } from '.'

export const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_BASE_URL,
  basePath: '/api/auth',
  plugins: [
    inferAdditionalFields<TAuth>(),
    organizationClient(),
    adminClient(),
    nextCookies(),
    magicLinkClient(),
  ],
  debug: true,
})

export const {
  signIn,
  signOut,
  signUp,
  useSession,
  getSession,
  organization,
  useListOrganizations,
  useActiveOrganization,
} = authClient
